module.exports = __webpack_public_path__ + "img/電気回路_1_2_5.be89d548.png";